import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CodeBlockChevronIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.6465 4.97982C11.8418 4.78456 12.1583 4.78456 12.3535 4.97982L15.0205 7.64681C15.2155 7.8421 15.2157 8.15869 15.0205 8.35384L12.3535 11.0199C12.1583 11.2151 11.8418 11.2151 11.6465 11.0199C11.4514 10.8246 11.4513 10.508 11.6465 10.3128L13.959 7.99935L11.6465 5.68685C11.4512 5.49159 11.4512 5.17508 11.6465 4.97982Z"
      fill="currentColor"
    />
    <path
      d="M3.64679 4.97983C3.84207 4.78473 4.15862 4.78462 4.35382 4.97983C4.54887 5.17505 4.54887 5.49164 4.35382 5.68686L2.04035 7.99936L4.35382 10.3128C4.54898 10.508 4.54876 10.8246 4.35382 11.0199C4.15856 11.2151 3.84205 11.2151 3.64679 11.0199L0.9798 8.35385C0.784592 8.15865 0.784701 7.8421 0.9798 7.64682L3.64679 4.97983Z"
      fill="currentColor"
    />
    <path
      d="M9.18975 2.51727C9.27225 2.25396 9.55231 2.1069 9.81573 2.18914C10.0793 2.27151 10.2262 2.55252 10.1439 2.8161L6.81085 13.4821C6.72848 13.7457 6.44747 13.8926 6.18389 13.8102C5.92059 13.7277 5.77353 13.4477 5.85577 13.1843L9.18975 2.51727Z"
      fill="currentColor"
    />
  </svg>
);
